export const GENERIC_ERROR_MESSAGE = 'Something went wrong';

export const MOBILE_SCREEN_BREAKPOINT_WIDTH = 555;
export const MOBILE_SCREEN_BREAKPOINT_HEIGHT = 555;
export const NEW_ID = 'NEW_ID';